module.exports = __webpack_public_path__ + "img/1 (57).3f8bbcaf.png";